export default __webpack_public_path__ + "static/media/Emerald Armbands.a0bc1d56.jpg";